import React from "react"
import { useTheme } from "@mui/material/styles"
import {
  Avatar,
  Box,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  listItemTextClasses,
  Skeleton,
  Tooltip,
  Typography
} from "@mui/material"

import MainCard from "./MainCard"

const SmallComparisonCard = ({
  icon,
  primaryText,
  primaryTextVariant = "h5",
  primarySubText = null,
  secondaryText,
  overflowSecondaryText = false,
  trailing = null,
  loading,
  color,
  iconColor,
  iconBackground,
  contentSx = { p: 2, py: "13px" },
  ...rest
}) => {
  const theme = useTheme()

  const avatarBackground =
    iconBackground ??
    (color === "primary"
      ? theme.palette.primary.light
      : theme.palette.secondary.light)
  const avatarColor =
    iconColor ??
    (color === "primary"
      ? theme.palette.primary.main
      : theme.palette.secondary.main)

  return (
    <MainCard border={false} content={false} {...rest}>
      <Box sx={contentSx}>
        <List
          sx={{
            py: 0,
            [`& .${listItemTextClasses.root}`]: {
              margin: "0 !important"
            }
          }}
        >
          <ListItem alignItems="center" disableGutters sx={{ py: 0 }}>
            <ListItemAvatar>
              {loading ? (
                <Skeleton variant="rectangular" width={32} height={32} />
              ) : (
                <Avatar
                  variant="rounded"
                  sx={{
                    ...theme.typography.commonAvatar,
                    ...theme.typography.mediumAvatar,
                    backgroundColor: avatarBackground,
                    color: avatarColor
                  }}
                >
                  {icon}
                </Avatar>
              )}
            </ListItemAvatar>
            <ListItemText
              disableTypography
              primary={
                loading ? (
                  <Skeleton variant="rectangular" height={16} />
                ) : (
                  <Typography variant={primaryTextVariant}>
                    {primaryText}{" "}
                    <Box fontWeight="normal" component="span">
                      {primarySubText}
                    </Box>
                  </Typography>
                )
              }
              secondary={
                loading ? (
                  <Skeleton variant="text" height={12} />
                ) : (
                  <Tooltip placement="top" title={secondaryText}>
                    <Typography
                      noWrap={!overflowSecondaryText}
                      lineHeight={1}
                      variant="subtitle2"
                      sx={{
                        color: theme.palette.grey[500],
                        ...(overflowSecondaryText && {
                          whiteSpace: { xs: "normal", sm: "nowrap" },
                          overflow: { xs: "hidden", sm: "visible" }
                        })
                      }}
                    >
                      {secondaryText}
                    </Typography>
                  </Tooltip>
                )
              }
            />
            {trailing && (
              <Box sx={{ ml: "auto", pl: 1, flexShrink: 0 }}>{trailing}</Box>
            )}
          </ListItem>
        </List>
      </Box>
    </MainCard>
  )
}

export default SmallComparisonCard
